/* eslint-disable */
import { MAT_SVG_ICON } from '@core/utils';
import { FuseNavigationItem } from '@fuse/components/navigation';

export const compactNavigation: FuseNavigationItem[] = [
    /* {
        id: 'dashboards',
        title: 'Panel',
        type: 'basic',
        icon: MAT_SVG_ICON.INDICATOR,
        link: '/main/dashboards',
    }, */
    /* {
        id: 'categories',
        title: 'Categorías',
        type: 'basic',
        icon: MAT_SVG_ICON.CATEGORY,
        link: '/main/categories',
    }, */
    /*  {
        id: 'tags',
        title: 'Etiquetas',
        type: 'basic',
        icon: MAT_SVG_ICON.TAG,
        link: '/main/tags',
    }, */
    /* {
        id: 'brands',
        title: 'Marca',
        type: 'basic',
        icon: MAT_SVG_ICON.RESERVATION,
        link: '/main/brands',
    }, */
    {
        id: 'inventory',
        title: 'Inventario',
        type: 'basic',
        icon: MAT_SVG_ICON.INVENTORY,
        link: '/main/inventory',
    },
    {
        id: 'users',
        title: 'Usuarios',
        type: 'basic',
        icon: MAT_SVG_ICON.USER_OUTLINE,
        link: '/main/users',
    },
    {
        id: 'settings',
        title: 'Configuración',
        type: 'basic',
        icon: MAT_SVG_ICON.SETTINGS_OUTLINE,
        link: '/main/settings',
    },
];

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboards',
        subtitle: 'Unique dashboard designs',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'dashboards.project',
                title: 'Project',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-check',
                link: '/dashboards/project',
            },
        ],
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards.project',
        title: 'Project',
        type: 'group',
        icon: 'heroicons_outline:clipboard-document-check',
        link: '/dashboards/project',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards.project',
        title: 'Project',
        type: 'group',
        icon: 'heroicons_outline:clipboard-document-check',
        link: '/dashboards/project',
    },
];
